<script setup lang="ts">
  import { useModalStore } from '@/stores/modal'
  import { watch } from 'vue'
  const modal = useModalStore()

  watch(
    () => modal.modals.length,
    () => {
      document.body.focus()
    },
  )
</script>

<template>
  <Transition
    enter-active-class="transition-opacity duration-200 ease-out"
    enter-from-class="opacity-0"
    leave-active-class="transition-opacity duration-200 ease-in"
    leave-to-class="opacity-0"
  >
    <div v-if="modal.modals.length && !modal.hiddenMode" class="fixed z-50 inset-0 bg-black-10/25" data-modal>
      <div
        v-for="(instance, key) in modal.modals"
        :key="key"
        class="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2"
        :class="{ 'opacity-0 pointer-events-none': modal.modals.length - 1 !== key }"
        role="dialog"
        :aria-hidden="modal.modals.length - 1 !== key || undefined"
        :inert="modal.modals.length - 1 !== key"
      >
        <Transition
          appear
          enter-active-class="transition-[opacity,scale,translate] duration-200 ease-out"
          enter-from-class="opacity-0 scale-95 translate-y-3"
          enter-to-class="opacity-100 scale-100 translate-y-0"
        >
          <component :is="instance.component" :closeModal="modal.close" :init="instance.init" />
        </Transition>
      </div>
    </div>
  </Transition>

  <template v-if="modal.modals.length && modal.hiddenMode">
    <div v-for="(instance, key) in modal.modals" :key="key" class="hidden">
      <component :is="instance.component" :closeModal="modal.close" :init="instance.init" />
    </div>
  </template>
</template>
